export const emailRegEx = /^([.0-9a-z+]+[^.,<>?!@#$%^&*()_+~|\\/])@([a-z0-9]{2,}(?:\.[a-z]{2,})+)$/;
// /^([-.!#-'*+/-9=?A-Z^-~]{3,61})@([0-9A-Za-z]{2,61}([0-9A-Za-z-]{0,61}[0-9A-Za-z])?(\.[0-9A-Za-z]{2,61}))$/;
